type RequiredEnvKey =
  | "REACT_APP_API_SITE_URL"
  | "REACT_APP_API_PUSH_URL"
  | "REACT_APP_API_STREAM_URL"
  | "REACT_APP_API_ARCHIVE_URL"
  | "REACT_APP_API_AI_URL"
  | "REACT_APP_API_EVOTOR_URL"
  | "REACT_APP_AI_ASSISTANT_API_URL";

function readEnv(key: string, fallback = ""): string {
  return (process.env[key] ?? fallback).trim();
}

function readRequiredEnv(key: RequiredEnvKey, fallback: string): string {
  const value = readEnv(key, fallback);
  if (!value) {
    throw new Error(`Missing env variable: ${key}`);
  }
  return value;
}

export const appEnv = {
  yandexMapsApiKey: readEnv("REACT_APP_YMAPS_API_KEY", "0adbb008-3071-4219-9486-f3377b7a8089"),
  buildVersion: readEnv("REACT_APP_BUILD_VERSION", "dev"),
  storageKey: readEnv("REACT_APP_STORAGE_KEY", "ifbx"),
  pushPublicKey: readEnv("REACT_APP_PUSH_PUBLIC_KEY"),
  appBaseUrl: readEnv("REACT_APP_APP_BASE_URL", window.location.origin),
  evotorOrgId: readEnv("REACT_APP_EV_ORG_ID"),
  evotorToken: readEnv("REACT_APP_EV_TOKEN"),
  api: {
    site: readRequiredEnv("REACT_APP_API_SITE_URL", "https://apifoodbox.ru/apiSite"),
    push: readRequiredEnv("REACT_APP_API_PUSH_URL", "https://api.ifbx.ru/api/v1"),
    stream: readRequiredEnv("REACT_APP_API_STREAM_URL", "https://vizhunet.ru/api/v1"),
    archive: readRequiredEnv("REACT_APP_API_ARCHIVE_URL", "https://vizhunet.ru/api/v1"),
    ai: readRequiredEnv("REACT_APP_API_AI_URL", "https://gpt-api.ifbx.ru"),
    aiAssistant: readRequiredEnv("REACT_APP_AI_ASSISTANT_API_URL", "https://ai-api.pinskiy.co/api/v2"),
    evotor: readRequiredEnv("REACT_APP_API_EVOTOR_URL", "https://backoffice.toka.rest"),
    courier: readEnv("REACT_APP_API_COURIER_URL", "https://apifoodbox.ru/apiCouriersApp"),
  },
  aiAssistantToken: readEnv("REACT_APP_AI_ASSISTANT_TOKEN"),
} as const;

export type AppEnv = typeof appEnv;
